import type { HelpFile } from '../../types/help'
import { ColorPickerTestIds } from '../../../testids/ColorPickerTestIds'

export const colorPickerHelp: HelpFile = {
  docPage: '/docs/admin/branding',
  texts: {
    [ColorPickerTestIds.btnColorPicker]:
      'Hex-Farbe für Branding-Akzente wählen — Links, Schaltflächen und Abzeichen.',
  },
}
